import AlumniShowcase from "../components/alumni/AlumniShowcase";
import GlobalNetwork from "../components/alumni/GlobalNetwork";
import Hero from "../components/alumni/Hero";
import AlumniAssociation from "../components/alumni/Meetup";
import OurImpact from "../components/alumni/OurImpact";

const Alumni = () => {
  return (
    <div>
      <Hero />
      <AlumniAssociation />
      <OurImpact />
      <GlobalNetwork />
      <AlumniShowcase />
    </div>
  );
};

export default Alumni;
